import { render, staticRenderFns } from "./WalletDetail.vue?vue&type=template&id=3930a606&"
import script from "./WalletDetail.vue?vue&type=script&lang=js&"
export * from "./WalletDetail.vue?vue&type=script&lang=js&"
import style0 from "./WalletDetail.vue?vue&type=style&index=0&id=3930a606&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports